<template>
    <div>
        <router-view />
    </div>
</template>

<!-- <style scoped src="@/assets/screened.css"></style>
<style scoped src="@/assets/global.css"></style> -->